export interface IMicrositeRecipientCompliance {
    id: number,
    firstName: string,
    lastName: string,
    link: string,
    complianceIssues: string[],
    itemCount: number
}